export default ({ request }) => ({
  ftyOrderFlowSettingListApi(data = {}) {
    return request({
      url: '/factory/fty/order/flow/setting/list',
      method: 'post',
      data,
    })
  },
  ftyOrderFlowSettingDetailApi(data = {}) {
    return request({
      url: '/factory/fty/order/flow/setting/detail',
      method: 'post',
      data,
    })
  },
  ftyOrderFlowSettingSaveApi(data = {}) {
    return request({
      url: '/factory/fty/order/flow/setting/save',
      method: 'post',
      data,
    })
  },
  ftyOrderFlowSettingDelApi(data = {}) {
    return request({
      url: '/factory/fty/order/flow/setting/del',
      method: 'post',
      data,
    })
  },
})
